import { type InferOutput, minLength, object, pipe, string } from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

export const CreateDcDtoSchema = object({
  name: pipe(string(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)),
  code: pipe(string(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM))
})

export type CreateDcDto = InferOutput<typeof CreateDcDtoSchema>
